'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const MinimizedOutlineIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="MinimizedOutlineIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 19H18V21H6V19Z" fill={sx?.color || 'white'} />
      </svg>
    </SvgIcon>
  )
}

MinimizedOutlineIcon.propTypes = {
  sx: PropTypes.object
}
